import React, { Component } from 'react';
import { Link, useHistory } from 'react-router-dom';
import i18n from 'i18next';
import _get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import layerSlayers from '../../assets/minerva-transparent.png';
import { ButtonWrapper, NormalText } from '../../styles/DashboardStyles';
import { HeaderImage } from '../../styles/HeaderStyles';
import { SmallButton, Wrapper } from '../../styles/HomeStyles';

const Header = props => {
  const history = useHistory();
  const changeLang = lang => {
    i18n.changeLanguage(lang);
  };

  const user = JSON.parse(localStorage.getItem('user'));

  const { t } = useTranslation();

  return (
    <Wrapper center={props.center}>
      {!props.isHome ? (
        <div
          style={{
            flexDirection: 'row',
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <div style={{ flexDirection: 'row', display: 'flex' }}>
            <Link to="#">
              <HeaderImage
                center={props.center}
                onClick={props.setTabIndex}
                home={true}
                src={layerSlayers}
              />
            </Link>
            <React.Fragment>
              <p
                style={{ paddingTop: 20, paddingLeft: 20 }}
                onClick={() => changeLang('en')}
              >
                English
              </p>
              <p
                style={{ paddingTop: 20, paddingLeft: 20 }}
                onClick={() => changeLang('es')}
              >
                Español
              </p>
            </React.Fragment>
          </div>
          <div>
            {!props.isHome && (
              <div style={{ flexDirection: 'row', display: 'flex' }}>
                {' '}
                <p
                  style={{ color: '#000', paddingRight: 15, paddingTop: 12 }}
                >{`${_get(user, 'name', '')} | ${_get(
                  user,
                  'userType.name',
                  ''
                )}`}</p>
                <ButtonWrapper>
                  <SmallButton
                    color="primary"
                    onClick={() => {
                      localStorage.removeItem('loginToken');
                      history.push('/');
                    }}
                  >
                    {t('Logout')}
                  </SmallButton>
                </ButtonWrapper>
              </div>
            )}
          </div>
        </div>
      ) : (
        <Link to="/">
          <HeaderImage center={props.center} home={true} src={layerSlayers} />
        </Link>
      )}
    </Wrapper>
  );
};

export default Header;
